import { render, staticRenderFns } from "./_UpdateVaccination.vue?vue&type=template&id=cdc4040c&scoped=true&"
import script from "./_UpdateVaccination.vue?vue&type=script&lang=ts&"
export * from "./_UpdateVaccination.vue?vue&type=script&lang=ts&"
import style0 from "./_UpdateVaccination.vue?vue&type=style&index=0&id=cdc4040c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc4040c",
  null
  
)

export default component.exports